import { render, staticRenderFns } from "./PercepcionConsulta.vue?vue&type=template&id=50ddbf6d&scoped=true&"
import script from "./PercepcionConsulta.vue?vue&type=script&lang=js&"
export * from "./PercepcionConsulta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ddbf6d",
  null
  
)

export default component.exports